export default __webpack_public_path__ + "static/media/Giving-Together.d87af5bc.gif";